import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ProgressIndicatorComponent } from '@app/shared/progress-indicator/progress-indicator.component';
import { ProgressModule } from '@app/shared/progress/progress.module';

@NgModule({
  declarations: [ProgressIndicatorComponent],
  imports: [CommonModule, ProgressModule],
  exports: [ProgressIndicatorComponent],
})
export class ProgressIndicatorModule {}
